import angular from 'angular';

angular.module('cxTable', ['commonServices', 'ui.bootstrap', 'infinite-scroll']);
